var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#21273B",
    fillRule: "evenodd",
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 2,
    y: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 2,
    y: 10,
    rx: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMenu);
export default __webpack_public_path__ + "static/media/nav-menu.df7f3eb6afa2bf82fe7d9c719f6c2fe2.svg";
export { ForwardRef as ReactComponent };